// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HighlightFilledSvg from "@ant-design/icons-svg/es/asn/HighlightFilled";
import AntdIcon from '../components/AntdIcon';

var HighlightFilled = function HighlightFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HighlightFilledSvg
  }));
};

HighlightFilled.displayName = 'HighlightFilled';
export default React.forwardRef(HighlightFilled);